module.exports = __webpack_public_path__ + "static/media/logo.2bfba075.svg";